import { render, staticRenderFns } from "./HesapTablosuInfo.vue?vue&type=template&id=cf36c978"
import script from "./HesapTablosuInfo.vue?vue&type=script&lang=ts"
export * from "./HesapTablosuInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports